// extracted by mini-css-extract-plugin
module.exports = {"priceValue":"InfoListValue_priceValue__vO28o"};